import { ReactElement } from 'react';
import { Box, Stack, Typography, Button, Paper } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import QuestionPreview from './QuestionPreview';

interface TemplatePreviewProps {
  sections: any[];
  onExitPreview: () => void;
}

export default function TemplatePreview({
  sections,
  onExitPreview,
}: TemplatePreviewProps): ReactElement {
  return (
    <Box>
      {/* Header */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Typography variant="h2">Template Preview</Typography>

        <Button
          variant="outlined"
          size="small"
          startIcon={<EditIcon fontSize="small" sx={{ mr: 1 }} />}
          onClick={onExitPreview}
        >
          Edit
        </Button>
      </Stack>

      {/* Sections */}
      <Stack spacing={2}>
        {sections.map((section) => (
          <Paper
            key={section.id}
            variant="outlined"
            sx={{
              borderRadius: 2,
              p: 3,
              borderColor: 'divider',
            }}
          >
            {/* Section title */}
            <Typography variant="h3" className="py-1">
              {section.title}
            </Typography>

            {/* Subsections */}
            {section.subsections.map((subsection: any) => (
              <Box key={subsection.title} mb={2}>
                <Typography variant="h4" className="py-1">
                  {subsection.title}
                </Typography>

                {subsection.questions.map((question: any) => (
                  <QuestionPreview key={question.id} question={question} />
                ))}
              </Box>
            ))}
          </Paper>
        ))}
      </Stack>
    </Box>
  );
}
